// Entry point for error reporting. Load this before any other app code so errors are captured as
// early as possible: the website loads it as its own blocking bundle at the top of <head>.
import { initDatadog } from "./datadog";
import {
  clearExceptionInCookie,
  getExceptionInCookie,
  handleError,
  installGlobalErrorHandlers,
  raiseError,
} from "./errorHandling";

// Used by the legacy fb.handle_error / fb.error shims.
const BancoTelemetry = { handleError, raiseError };

export type BancoTelemetryApi = typeof BancoTelemetry;

if (!window.BancoTelemetry) {
  // Absent when Datadog is disabled (e.g. development and test).
  if (window.bancoDatadogConfig) {
    initDatadog(window.bancoDatadogConfig);
  }
  installGlobalErrorHandlers();

  window.BancoTelemetry = BancoTelemetry;
  window.getExceptionInCookie = getExceptionInCookie;
  window.clearExceptionInCookie = clearExceptionInCookie;
}
